<template lang="pug">
    .plan-form
        SvButton.plan-form__remove(
            view="shadow"
            icon
            :prependIcon=`{
            icon: 'trash',
            width: 24,
            height: 24,
            hover: '#1993EB',
            default: '#B7BAC6'
        }`
            @click="remove"
        )

        .plan-form__image-wrapper
            img.plan-form__image(
                :src="uploadImage || value.icon"
            )

            .plan-form__image-hover
                SvUpload.form-residential-photo__upload(
                    v-model="value.icon"
                    :isImage="false"
                )

        .plan-form__input-container
            SvTextarea(
                v-model="value.description"
                placeholder="Описание решения"
                :rows="2"
            )

        .plan-form__input-container
            .sv-input-list
                .sv-input-list__item
                    SvInput._full-width(
                        color="graylight"
                        placeholder="Пункт 1"
                        :value="items[0].name"
                        @input="add_item_0"
                        :withIcon="false"
                    )
                .sv-input-list__item
                    SvInput._full-width(
                        color="graylight"
                        placeholder="Пункт 2"
                        :value="items[1].name"
                        @input="add_item_1"
                        :withIcon="false"
                    )
                .sv-input-list__item
                    SvInput._full-width(
                        color="graylight"
                        placeholder="Пункт 3"
                        :value="items[2].name"
                        @input="add_item_2"
                        :withIcon="false"
                    )
                .sv-input-list__item
                    SvInput._full-width(
                        color="graylight"
                        placeholder="Пункт 4"
                        :value="items[3].name"
                        @input="add_item_3"
                        :withIcon="false"
                    )
</template>

<script>
import SvButton from '@/components/uikit/SvButton.vue';
import SvSelect from '@/components/uikit/SvSelect.vue';
import SvInput from '@/components/uikit/SvInput.vue';
import SvRadio from '@/components/uikit/SvRadio.vue';
import SvUpload from '@/components/uikit/SvUpload.vue';
import SvTextarea from '@/components/uikit/SvTextarea.vue';
import SvInputList from '@/components/uikit/SvInputList.vue';

export default {
    name: 'SolutionForm',
    data() {
        return {
            uploadImage: null
        }
    },

    components: {
        SvSelect,
        SvInput,
        SvRadio,
        SvButton,
        SvUpload,
        SvTextarea,
        SvInputList,
    },

    props: {
        value: {
            type: Object,
            required: true,
        },
    },

    computed: {

        icon: {
            get() {
                return this.value.icon;
            },
            set(icon) {
                this.uploadImage = icon;
                this.setValue({icon});
            },
        },

        items: {
            get() {
                this.value.items = this.value.items.filter(item => !!item.name);
                if (this.value.items.length < 4) {
                    for (let i = 3 - this.value.items.length; i >= 0; i--) {
                        this.value.items.push({name: ''});
                    }
                }
                return this.value.items;
            },
            set(items) {
                this.setValue({items: this.value.items.filter(item => !!item.name)});
            },
        },
    },

    methods: {
        setValue(val) {
            this.$emit('input', {
                ...this.value,
                ...val,
            });
        },

        remove() {
            this.$emit('remove');
        },

        add_item_0(v) {
            this.value.items[0].name = v;
        },
        add_item_1(v) {
            this.value.items[1].name = v;
        },
        add_item_2(v) {
            this.value.items[2].name = v;
        },
        add_item_3(v) {
            this.value.items[3].name = v;
        },
    },
};
</script>

<style lang="scss" scoped>
.plan-form {
    position: relative;
    box-shadow: 0px 5px 20px rgba(3, 62, 105, 0.08);
    border: 1px solid #E4E4EE;
    border-radius: 6px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;

    &__remove {
        position: absolute;
        right: 3px;
        top: 3px;
        z-index: 10;
    }

    &__image-wrapper {
        position: relative;
        height: 217px;
        width: 207px;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
            .plan-form__image-hover {
                opacity: 1;
            }
        }
    }

    &__image-hover {
        opacity: 0;
        position: absolute;
        background-color: rgba(255, 255, 255, .7);
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &__image {
        max-width: 207px;
        max-height: 217px;
        text-align: center;
    }

    &__input-container {
        width: 215px;
        margin-top: 30px;
    }

    &__input,
    &__balcony {
        margin-top: 20px;
    }

    &__balcony {
        display: flex;

        &-label {
            margin-right: 40px;
        }

        &-group {
            display: flex;
            justify-content: space-between;
            width: 100%;
        }
    }
}

.sv-input-list {
    &__item:nth-child(n+2) {
        margin-top: 10px;
    }
}
</style>
